import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Link, Route, Switch, useHistory, useLocation } from "react-router-dom";
import './App.css';
import axios from 'axios';

import CIcon  from '@coreui/icons-react';
import { cilX, cilHamburgerMenu } from '@coreui/icons';

import Menu from './components/js/Menu';
import FoodMenu from './components/js/FoodMenu';
import ThePlace from './components/js/ThePlace';
import Contact from './components/js/Contact';
import ContactInfo from './components/js/ContactInfo';

import Reservations from './components/js/Reservations';

import Item1InFoodMenu from './components/js/Item1InFoodMenu';
import Item2InFoodMenu from './components/js/Item2InFoodMenu';
import Item3InFoodMenu from './components/js/Item3InFoodMenu';
import Item4InFoodMenu from './components/js/Item4InFoodMenu';
import Item5InFoodMenu from './components/js/Item5InFoodMenu';
import Item6InFoodMenu from './components/js/Item6InFoodMenu';
import Item7InFoodMenu from './components/js/Item7InFoodMenu';
import Item8InFoodMenu from './components/js/Item8InFoodMenu';
import Item9InFoodMenu from './components/js/Item9InFoodMenu';

import Signup from './components/js/Signup';
import Login from './components/js/Login';
import Logout from './components/js/Logout';
import Reset from './components/js/Reset';
import ResetConfirm from './components/js/ResetConfirm';
import Dashboard from './components/js/Dashboard';

import Menus from './components/js/Menus';
import MenuPostres from './components/js/MenuPostres';
import MenuVinos from './components/js/MenuVinos';
import MenuVinosCopeo from './components/js/MenuVinosCopeo';
import MenuDestilados from './components/js/MenuDestilados';
import MenuCocteleria from './components/js/MenuCocteleria';

import {
  FooterElement,
  DividerLineInFooter,
  ContainerNavBarInFooter,
  NavBarItem,
  StyledLink,
  ContainerSocialNetworks,
  SocialNetworks,

  ButtomMenuAbsolute,
  ContainerMenuAbsolute,
  ContainerChildHeaderMenuAbsolute,
  ContainerChildMenuAbsolute,
  ChildMenuAbsolute

} from './components/js/Styles'; // Ajusta la ruta según tu estructura

function NavBar(){

  const [open_or_close_menu, setOpenOrCloseMenu] = useState("0");

  return (
    <nav>
      <ButtomMenuAbsolute onClick={()=> setOpenOrCloseMenu(open_or_close_menu === "1" ? "0" : "1")}>
        <CIcon icon={open_or_close_menu === "1" ? cilX : cilHamburgerMenu} className="flex-shrink-0 me-2 text-white" width={24} height={24} />
      </ButtomMenuAbsolute>
      
      <ContainerMenuAbsolute open_or_close={open_or_close_menu}>
        <ContainerChildMenuAbsolute>
          <ChildMenuAbsolute to={"/"} onClick={()=> setOpenOrCloseMenu("0")}>INICIO</ChildMenuAbsolute>
          <ChildMenuAbsolute to={"/food_menu"} onClick={()=> setOpenOrCloseMenu("0")}>NUESTRA CARTA</ChildMenuAbsolute>
          <ChildMenuAbsolute to={"/contact_info"} onClick={()=> setOpenOrCloseMenu("0")}>CONTACTO</ChildMenuAbsolute>
        </ContainerChildMenuAbsolute>
      </ContainerMenuAbsolute>
    </nav>
  );
}

function Footer({navbar_type, option}){

  const [userLocation, setUserLocation] = useState("");
  const location = useLocation();
  const [view_active, setViewActive] = useState("");
  const [categories_products, SetCategoriesProducts] = useState([]);

  const apiDomain = process.env.REACT_APP_DOMAIN_API;
  const withSSL = process.env.REACT_APP_SSL;

  const get_list_categories_products = async() => {
  
      await axios.get(`http${withSSL}://${apiDomain}/api/no_auth/categories_products/`).then(
          response => {
              SetCategoriesProducts(response.data);
          }
      ).catch(
          error => console.log(error)
      )
  
  }
  
  const locationList = [
    "/food_menu",
    "/the_place",
    "/contact_info",
    "/reservations",
    "/item_1_in_food_menu",
    "/item_2_in_food_menu",
    "/item_3_in_food_menu",
    "/item_4_in_food_menu",
    "/item_5_in_food_menu",
    "/item_6_in_food_menu",
    "/item_7_in_food_menu",
    "/item_8_in_food_menu",
    "/",
  ]

  const exteriorLocationList = [
    "https://wa.me/2225594450/",
    "https://facebook.com/profile.php?id=100087916872647",
    "https://www.instagram.com/restaurante.bardo/"
  ]

  const { latitude, longitude } = userLocation;
  const businessName = "Restaurante+Bardo";

  const googleMapsUrl = `https://www.google.com.mx/maps/place/Restaurante+Bardo/@19.0532175,-98.2296612,17z/data=!3m1!4b1!4m6!3m5!1s0x85cfc7676660739d:0x8a81dda19c3b3b13!8m2!3d19.0532175!4d-98.2270863!16s%2Fg%2F11k3h7vzdh?entry=ttu`;

  function fadeInOnScroll() {
    var elementos = document.getElementsByClassName("fade-in");

    for (var i = 0; i < elementos.length; i++) {
        var elemento = elementos[i];
        var posicion = elemento.getBoundingClientRect().top;
        var alturaVentana = window.innerHeight/1.2;
        var offset = 10; // Valor de desplazamiento adicional para controlar cuándo se debe mostrar el elemento

        if (posicion < alturaVentana - offset) {
            elemento.classList.add("visible");
            elemento.style.animation = "fadeInFromBottom 0.9s ease-in-out";
        } else {
            elemento.classList.remove("visible");
            elemento.style.animation = "";
        }
        
    }
  }

  window.addEventListener("scroll", fadeInOnScroll);

  useEffect(() => {
    fadeInOnScroll();
    // Verificar la ubicación actual y establecer la vista activa
    for (let i = 0; i < locationList.length; i++) {
      if (location.pathname === locationList[i]) {
        setViewActive(locationList[i]);
        break; // Terminar el bucle una vez que se encuentra la coincidencia
      }
    }
  }, [location.pathname]); // El arreglo vacío [] asegura que el efecto se ejecute solo una vez

  
  useEffect(() => {
      get_list_categories_products();
  }, []); // El arreglo vacío [] asegura que el efecto se ejecute solo una vez


  function newTab(url) {
    window.open(url, '_blank');
  }

  return(
    <FooterElement className="fade-in" plural={navbar_type === undefined ? "1" : ""} option={option}>
      {
        navbar_type ===  "1" ?
        <></>
        :
        <>
          <DividerLineInFooter />
          <ContainerNavBarInFooter>
            {
              categories_products.length > 0 ?
              categories_products.map((category_product, index) => (
                <NavBarItem key={category_product.id}>
                  <StyledLink to={category_product.nombre.toLowerCase().includes("desti") ? '/item_6_in_food_menu' : category_product.nombre.toLowerCase().includes("vino") ? '/item_8_in_food_menu' : `/item_1_in_food_menu/${category_product.id}`}>{category_product.nombre.toUpperCase()}</StyledLink>
                  {
                    view_active === locationList[4] ?
                    <DividerLineInFooter />
                    : <></>
                  }
                </NavBarItem>
              ))
              : <></>
            }
          </ContainerNavBarInFooter>
          <ContainerNavBarInFooter>
            <NavBarItem>
              <StyledLink to={locationList[12]}>MENÚ</StyledLink>
              {
                view_active === locationList[12] || view_active === locationList[0] ?
                <DividerLineInFooter />
                : <></>
              }
            </NavBarItem>
            <NavBarItem>
              <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer"className="navBarItemLink">EL LUGAR</a>
              {
                view_active === locationList[13] ?
                <DividerLineInFooter />
                : <></>
              }
            </NavBarItem>
            <NavBarItem>
              <StyledLink to={locationList[2]}>CONTACTO</StyledLink>
              {
                  view_active === locationList[2] || view_active === locationList[14] ?
                  <DividerLineInFooter />
                  : <></>
                }
            </NavBarItem>
            <NavBarItem>
              <a className="navBarItemLink">©2026 BARDO</a>     
            </NavBarItem>
          </ContainerNavBarInFooter>
          <ContainerNavBarInFooter>
            <NavBarItem>
            <a className="navBarItemLink">REDES SOCIALES</a>
            </NavBarItem>
            <ContainerSocialNetworks>
              <SocialNetworks tabIndex={8} onClick={() => newTab(exteriorLocationList[0])}>
                <div></div>
              </SocialNetworks>
              <SocialNetworks tabIndex={9} onClick={() => newTab(exteriorLocationList[1])}>
                <div></div>
              </SocialNetworks>
              <SocialNetworks tabIndex={10} onClick={() => newTab(exteriorLocationList[2])}>
                <div></div>
              </SocialNetworks>
            </ContainerSocialNetworks>
          </ContainerNavBarInFooter>
        </>
      }
    </FooterElement>
  );
}

function App() {
  const history = useHistory();
  const tokenGet = localStorage.token

  const [token, setToken] = useState("");

  const userLogin = (tok) => {

    setToken(tok)

  }

  //useEffect(() => {
    
  //  if(tokenGet != undefined || tokenGet != null){
  //   console.log("este ususario ya tiene session iniciada")
  //  }
  // else{
  //   console.log("sin session iniciada");
  //  }

  //}, []);

  return (
    <Router>
      <div className="App">
        {/* Rutas */}
        <Switch>
          <Route path="/" exact>
            <NavBar />
            <Menu />
          </Route>
          <Route path="/food_menu" exact>
            <FoodMenu />            
            <Footer/>
          </Route>
          <Route path="/the_place" exact>
            <NavBar />
            <ThePlace />
          </Route>
          <Route path="/contact" exact>
            <NavBar />
            <Contact />
          </Route>
          <Route path="/contact_info" exact>
              <ContactInfo />
              <Footer />
            </Route>
          <Route path="/reservations" exact>
            <NavBar />
            <Reservations />
            <Footer />
          </Route>

          <Route path="/item_1_in_food_menu/:category_product_id" exact>
            <NavBar />
            <Item1InFoodMenu />
            <Footer />
          </Route>
          <Route path="/item_2_in_food_menu" exact>
            <NavBar />
            <Item2InFoodMenu />
            <Footer />
          </Route>
          <Route path="/item_3_in_food_menu" exact>
            <NavBar />
            <Item3InFoodMenu />
            <Footer />
          </Route>
          <Route path="/item_4_in_food_menu" exact>
            <NavBar />
            <Item4InFoodMenu />
            <Footer />
          </Route>
          <Route path="/item_5_in_food_menu" exact>
            <NavBar />
            <Item5InFoodMenu />
            <Footer />
          </Route>
          <Route path="/item_6_in_food_menu" exact>
            <NavBar />
            <Item6InFoodMenu />
            <Footer />
          </Route>
          <Route path="/item_7_in_food_menu" exact>
            <NavBar />
            <Item7InFoodMenu />
            <Footer />
          </Route>
          <Route path="/item_8_in_food_menu" exact>
            <NavBar />
            <Item8InFoodMenu />
            <Footer />
          </Route>
          <Route path="/item_9_in_food_menu" exact>
            <NavBar />
            <Item9InFoodMenu />
            <Footer />
          </Route>
          <Route path="/signup" exact>
            <Signup />
            <Footer />
          </Route>
          <Route path="/login" exact>
            <Login userLogin={userLogin}/>
            <Footer />
          </Route>
          <Route path="/dashboard" exact>
            <Dashboard token={token} />
            <Footer />
          </Route>
          <Route path="/logout" exact>
            <Logout />
            <Footer />
          </Route>
          <Route path="/reset_password" exact>
            <Reset />
            <Footer />
          </Route>
          <Route path="/reset_password_confirm/:token" exact>
            <ResetConfirm />
            <Footer />
          </Route>

          <Route path="/menus" exact>
            <Menus />
            <Footer />
          </Route>
          <Route path="/menu_postres" exact>
            <MenuPostres />
          </Route>
          <Route path="/menu_vinos" exact>
            <MenuVinos />
          </Route>
          <Route path="/menu_vinos_copeo" exact>
            <MenuVinosCopeo />
          </Route>
          <Route path="/menu_destilados" exact>
            <MenuDestilados />
          </Route>
          <Route path="/menu_cocteleria" exact>
            <MenuCocteleria />
          </Route>
          
        </Switch>
      </div>
    </Router>
  );
}

export default App;